import React, { Component } from 'react';
import '@bit/smartworks.unity.unity-core/unity-page-header';
export default class UnityPageHeader extends Component {
    constructor() {
        super(...arguments);
        this.headerRef = React.createRef();
    }
    componentDidMount() {
        this.updateProperties();
    }
    componentDidUpdate(oldProps) {
        this.updateProperties(oldProps);
    }
    updateProperties(oldProps = {}) {
        const { onTabSelect: oldTabSelect } = oldProps;
        const { onTabSelect = () => { } } = this.props;
        const headerElement = this.headerRef.current;
        if (!headerElement)
            return;
        if (onTabSelect !== oldTabSelect) {
            headerElement.onTabSelect = onTabSelect;
        }
    }
    render() {
        const { header = '', tabs = [], selectedTab, leftContent, centerContent, leftAction, rightAction, style } = this.props;
        const tabsStr = JSON.stringify(tabs);
        return React.createElement("unity-page-header", { style: style, ref: this.headerRef, header: header, tabs: tabsStr, selectedTab: selectedTab },
            !!leftContent &&
                React.createElement("div", { slot: "left-content" }, leftContent),
            !!centerContent &&
                React.createElement("div", { slot: "center-content" }, centerContent),
            !!leftAction &&
                React.createElement("div", { slot: "left-action" }, leftAction),
            !!rightAction &&
                React.createElement("div", { slot: "right-action" }, rightAction));
    }
}
